import React, { useState } from "react";
import {
  IconX,
  IconPhone,
  IconMail,
  IconUsers,
  IconChecklist,
  IconBrandWhatsapp,
  IconNote,
} from "@tabler/icons-react";
import { createActivity } from "../services/activities.service";
import { useCRM } from "../CRMContext";

const ACTIVITY_TYPES = [
  { value: "call", label: "Ligação", icon: IconPhone },
  { value: "email", label: "E-mail", icon: IconMail },
  { value: "meeting", label: "Reunião", icon: IconUsers },
  { value: "task", label: "Tarefa", icon: IconChecklist },
  { value: "whatsapp", label: "WhatsApp", icon: IconBrandWhatsapp },
  { value: "note", label: "Nota", icon: IconNote },
];

const ActivityForm = ({ contactId, pipelineId, onClose, onCreated }) => {
  const { state, showToast } = useCRM();
  const [title, setTitle] = useState("");
  const [activityType, setActivityType] = useState("call");
  const [scheduledAt, setScheduledAt] = useState("");
  const [durationMinutes, setDurationMinutes] = useState("");
  const [description, setDescription] = useState("");
  const [assignedTo, setAssignedTo] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim()) return;

    setSubmitting(true);
    try {
      const data = {
        contact: contactId,
        pipeline: pipelineId,
        title: title.trim(),
        activity_type: activityType,
        scheduled_at: scheduledAt || undefined,
        duration_minutes: durationMinutes ? Number(durationMinutes) : undefined,
        description: description.trim() || undefined,
        assigned_to: assignedTo || undefined,
      };
      const created = await createActivity(data);
      showToast("Atividade criada com sucesso!");
      onCreated?.(created);
      onClose();
    } catch {
      showToast("Erro ao criar atividade.", "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="crm-modal-backdrop" onClick={onClose}>
      <div className="crm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="crm-modal__header">
          <h3 className="crm-modal__title">Nova Atividade</h3>
          <button className="crm-drawer__close" onClick={onClose}>
            <IconX size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="crm-modal__body">
            <div className="crm-form-group">
              <label className="crm-label">Tipo</label>
              <div className="crm-activity-form__type-grid">
                {ACTIVITY_TYPES.map(({ value, label, icon: Icon }) => (
                  <button
                    key={value}
                    type="button"
                    className={`crm-activity-form__type-btn ${activityType === value ? "crm-activity-form__type-btn--active" : ""}`}
                    onClick={() => setActivityType(value)}
                  >
                    <Icon size={20} />
                    {label}
                  </button>
                ))}
              </div>
            </div>

            <div className="crm-form-group">
              <label className="crm-label">Título</label>
              <input
                className="crm-input"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Ex: Follow-up com cliente"
                required
              />
            </div>

            <div className="crm-form-row">
              <div className="crm-form-group">
                <label className="crm-label">Data/Hora</label>
                <input
                  type="datetime-local"
                  className="crm-input"
                  value={scheduledAt}
                  onChange={(e) => setScheduledAt(e.target.value)}
                />
              </div>

              <div className="crm-form-group">
                <label className="crm-label">Duração (min)</label>
                <input
                  type="number"
                  className="crm-input"
                  value={durationMinutes}
                  onChange={(e) => setDurationMinutes(e.target.value)}
                  placeholder="30"
                  min="1"
                />
              </div>
            </div>

            <div className="crm-form-group">
              <label className="crm-label">Responsável</label>
              <select className="crm-select" value={assignedTo} onChange={(e) => setAssignedTo(e.target.value)}>
                <option value="">Selecionar...</option>
                {state.teamMembers.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.first_name} {m.last_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="crm-form-group">
              <label className="crm-label">Descrição</label>
              <textarea
                className="crm-textarea"
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Detalhes da atividade..."
              />
            </div>
          </div>

          <div className="crm-modal__footer">
            <button type="button" className="crm-btn" onClick={onClose}>Cancelar</button>
            <button type="submit" className="crm-btn crm-btn--primary" disabled={submitting}>
              {submitting ? "Salvando..." : "Criar Atividade"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ActivityForm;
